import { useState, useEffect, useRef } from 'react';
import { Card, Row, Col } from 'antd';
import Cookies from 'js-cookie'; // Import js-cookie


const row_name = { description: { en: "Description", de: "Beschreibung" }, date: { en: "Date", de: "Datum" }, technic: { en: "Technologies", de: "Technologien" } };


const ShowSkills = ({ skillsList, selectedTags, selectedElement }) => {
  const [language, setLanguage] = useState(Cookies.get('language') || 'de'); // Initialize language from cookie
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    const handleCookieChange = () => {
      const newLanguage = Cookies.get('language') || 'de';
      setLanguage(newLanguage); // Update language state when cookie changes
    };

    // Monitor cookie changes (polling or custom logic)
    const interval = setInterval(handleCookieChange, 1000); // Check every second

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  useEffect(() => {
    if (selectedElement !== null && selectedElement[1] === "projects") {

    }
  }, [selectedElement]);

  useEffect(() => {
    setSkills(skillsList);
    console.log("SkillsList2", skillsList);
  }, [skillsList]);


  useEffect(() => {
    var showProjects = [];
    if (selectedTags.length > 0) {
      for (let i = 0; i < skillsList.length; i++) {
        var projectTags = skillsList[i]["technic"];
        for (let j = 0; j < projectTags.length; j++) {
          if (selectedTags.includes(projectTags[j]["name"])) {
            showProjects.push(skillsList[i]);
            break;
          }
        }

      }
    } else {
      showProjects = skillsList;
    }
    setSkills(showProjects)
    console.log("SkillsList3", skillsList);
  }, [selectedTags, skillsList]);

  // Create a ref object to hold refs for each project by id
  const skillsRefs = useRef({});

  useEffect(() => {
    console.log("check element:");
    console.log(selectedElement);
    if (
      selectedElement !== null &&
      selectedElement[1] === "Skills"
    ) {
      console.log("success");
      skillsRefs.current[selectedElement[0]].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedElement, skills]);



  return (
    <div style={{ background: 'linear-gradient(to right,rgb(175, 82, 175),rgb(39, 39, 131))' }}>
      <Row gutter={[16, 16]} style={{ padding: '20px' }}>
        {skills.map((project, index) => (
          <Col
            key={project.id || index}
            span={24}
            ref={el => {
              if (project.id) skillsRefs.current[project.id] = el;
            }}
          >
            <Card
              title={<div style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>{project.title[language]}</div>}
              bordered={true}
              style={{
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                maxWidth: 700,
                margin: '24px auto',
              }}
            >
              <p style={{ marginTop: '-20px' }}>
                <strong>{row_name.description[language]}:</strong>
                <br />
                {project.description[language]}
              </p>
              <p>
                <strong>{row_name.technic[language]}:</strong>
                <br />
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  {project.technic.map((tech, techIndex) => (
                    <div
                      key={techIndex + 20}
                      style={{
                        backgroundColor: tech.color,
                        color: 'white',
                        padding: '5px 10px',
                        borderRadius: '8px',
                        textAlign: 'center',
                        minWidth: '80px',
                      }}
                    >
                      {tech.name}
                    </div>
                  ))}
                </div>
              </p>
              {project.links && project.links.length > 0 &&(
                <p>
                  <strong>Links:</strong>
                  <br />
                  {project.links.map(link => (
                    <a
                      key={link.url}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: "block" }}
                    >
                      {link.label}
                    </a>
                  ))}
                </p>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ShowSkills;